import { Card, CardActions, CardContent, CardHeader, Container, Grid, Stack, Step, StepLabel, Stepper, Typography, Button } from '@mui/material';

const fallbackPlans = [
    { id: 1, name: 'Plano Essencial', description: 'Ideal para quem está começando. Inclui cadastro de ofertas e painel de resgates.', price: 'R$ 199/mês' },
    { id: 2, name: 'Plano Profissional', description: 'Suporte prioritário, múltiplos usuários e integrações.', price: 'R$ 349/mês' },
];

const steps = ['Escolha do plano', 'Assinatura do contrato', 'Pagamento', 'Criação da conta'];

export default function AdvertiserOnboarding() {
    const plans = fallbackPlans;

    return (
        <Container maxWidth="lg" sx={{ py: 6 }}>
            <Stack spacing={4}>
                <Typography variant="h3" textAlign="center" fontWeight="bold">
                    Comece a vender com a Eurobem
                </Typography>
                <Typography textAlign="center" color="text.secondary">
                    Siga o passo a passo para selecionar o plano ideal, assinar o contrato e criar sua conta de anunciante.
                </Typography>

                <Stepper activeStep={0} alternativeLabel>
                    {steps.map(step => (
                        <Step key={step}>
                            <StepLabel>{step}</StepLabel>
                        </Step>
                    ))}
                </Stepper>

                <Grid container spacing={3}>
                    {plans.map(plan => (
                        <Grid item xs={12} md={6} key={plan.id}>
                            <Card variant="outlined">
                                <CardHeader title={plan.name} subheader={plan.price} />
                                <CardContent>
                                    <Typography>{plan.description}</Typography>
                                </CardContent>
                                <CardActions>
                                    <Button fullWidth variant="contained">
                                        Escolher plano
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Stack>
        </Container>
    );
}

